var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38806 31.4156C0.728922 31.6931 0 31.2091 0 30.4939V1.50608C0 0.790901 0.728923 0.306915 1.38806 0.584445L35.8111 15.0784C36.627 15.4219 36.627 16.5781 35.8111 16.9216L1.38806 31.4156ZM3 27.35L28.0029 16.9168C28.8206 16.5756 28.8234 15.418 28.0072 15.0729L3 4.5V12.1239C3 12.5806 3.30941 12.9793 3.75182 13.0926L11.2568 15.0154C12.2633 15.2732 12.2577 16.7047 11.2493 16.9547L3 19V27.35ZM3 27.35V4.5V19V27.35Z",
    fill: "#5D6B82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.8da1e39e144d319f8bf9f702e10c5f25.svg";
export { ForwardRef as ReactComponent };